import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import "./Intervention.css";
import withAuth from "../../components/withAuth";
import { withRouter } from "react-router-dom";
import {
    fieldValueChange,
    getStartedWorkOrder,
    setImputationRedirectionModalOpenned,
    interventionsIsLoading,
} from "../../redux/intervention/interventionActions";
import {
    validateSignature,
    submitInterventionInDb,
    cancelSignature,
} from "../../redux/intervention/interventionEditionActions";
import { loadCurrentTimeSlot } from "../../redux/imputationInterventionRel/imputationInterventionRelActions";
import FooterFixedOnScreen from "../Layout/FooterFixedOnScreen";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import VariableTab from "../../components/Interventions/InterventionTabs/VariableTab";
import moment from "moment";
import ImputationRedirectionModal from "../../components/Interventions/ImputationRedirectionModal";
import { getStateAccessor } from "../../lib/evaluateStringAsCodeHelper";
import DetailTab from "../../components/Interventions/InterventionTabs/DetailTab";
import ReportTab from "../../components/Interventions/InterventionTabs/ReportTab";
import { getCurrentFunctionName } from "../../performanceModeManager";
import UpdatingBlocModal from "../../components/Interventions/UpdatingBlocModal";
import { SIGNATURES_BLOC_TYPE_CODE } from "../../redux/intervention/interventionConstants";
import { throwErrorMessage, throwInfo } from "../../lib/error_helper";

class InterventionSignature extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            blocs: this.getBlocs(),
            getBlocs: this.getBlocs.bind(this),
            mapOfBlocIdAndBlocIndex: {},
        };

        if (!this.props.intervention) this.props.history.push("/interventions");
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.intervention) nextProps.saveIntervention(nextProps.intervention, nextProps.blocs);

        let state = prevState;
        state.blocs = prevState.getBlocs();
        return state;
    }

    getBlocs() {
        let blocs = [];
        this.props.blocs.forEach((b) => {
            let bt = this.props.blocTypes.find((bt) => bt.id === b.type_id);

            if (!bt) {
                console.error("Type de bloc introuvable", b, bt, this.props.blocTypes);
                return [];
            }

            if (bt.display_to_customer) blocs.push(b);
        });

        return blocs;
    }

    fieldValueChange(blocId, fieldId, value) {
        this.props.fieldValueChange(
            blocId,
            fieldId,
            value,
            this.props.blocs,
            this.props.activeUser.id,
            this.props.intervention
        );
    }

    addOrRemoveBloc() {
        //On ne peut pas créer de bloc en signature
    }

    cancelSignature() {
        this.props.cancelSignature(this.props.history, false);
    }

    closeImputationRedirectionModal() {
        this.props.setImputationRedirectionModalOpenned(false);
        this.props.history.push("/interventions/intervention");
    }

    confirmationPopup() {
        var blocTypesUnsigned = [];
        this.props.blocs.forEach((bloc) => {
            var blocType = this.props.blocTypes.find((bt) => bt.id === bloc.type_id);
            if (blocType.require_customer_signature && !bloc.signed_by_customer && !bloc.deleted) {
                blocTypesUnsigned.push(blocType);
            }
        });
        if (blocTypesUnsigned && blocTypesUnsigned.length > 0) {
            var message = "Des documents ne sont pas signés par le client :<br/><br/>";
            blocTypesUnsigned.forEach((bt, i) => {
                message = message.concat("-", bt.name, "<br/>");
                if (i === blocTypesUnsigned.length - 1) {
                    message = message.concat("<br/>");
                }
            });
            message = message.concat("Valider quand même ?");

            var buttons = [
                {
                    name: "Valider",
                    primary: true,
                    onClick: () => this.stopAndValidate(),
                },
                {
                    name: "Annuler",
                    primary: false,
                    onClick: () => {
                        return;
                    },
                },
            ];
            this.props.throwInfo({
                id: "confirmationPopup",
                title: "Attention",
                message: message,
                buttons: buttons,
                allowHTML: true,
                dismissAfter: 0,
            });
        } else {
            this.stopAndValidate();
        }
    }

    stopAndValidate() {
        this.props.interventionsIsLoading(true);
        getStartedWorkOrder()
            .then((intervention) => {
                if (intervention)
                    this.props
                        .loadCurrentTimeSlot(intervention.report_block_ids, this.props.blocTypes, this.props.activeUser)
                        .then((timeSlot) => {
                            this.props.interventionsIsLoading(false);

                            if (timeSlot) {
                                timeSlot.endDate = moment().seconds(0).milliseconds(0);
                                timeSlot.endTime = moment().seconds(0).milliseconds(0);

                                this.props.validateSignature(
                                    this.props.intervention,
                                    timeSlot,
                                    this.props.blocs,
                                    this.props.activeUser,
                                    this.props.blocTypes,
                                    this.props.history,
                                    getStateAccessor(this.props)
                                );
                                this.forceUpdate();
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.props.interventionsIsLoading(false);
                        });
            })
            .catch((err) => {
                console.error(err);
                this.props.interventionsIsLoading(false);
            });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.intervention.internalState !== nextProps.intervention.internalState ||
            this.props.intervention.state !== nextProps.intervention.state ||
            this.props.blocs.length !== nextProps.blocs.length ||
            this.state.blocs.length !== nextState.blocs.length ||
            this.props.updatingBloc !== nextProps.updatingBloc ||
            this.state.expanded !== nextState.expanded
        );
    }

    onBlocHeaderClick = () => {
        this.setState((prevState) => ({
            expanded: !prevState.expanded,
        }));
    };

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.intervention) return <div />;

        let removableCategories = [];

        this.props.blocTypes
            .filter((bt) => bt.published)
            .map((bt) => bt.category_id)
            .forEach((c) => {
                if (removableCategories.every((rc) => rc.id !== c.id) && c.removable) removableCategories.push(c);
            });
        let categoryTabs = [];

        removableCategories
            .sort((c) => c.sequence)
            .forEach((c, i) => {
                categoryTabs.push({
                    name: c.name,
                    content: (
                        <VariableTab
                            key={i}
                            category={c}
                            fieldValueChange={this.fieldValueChange.bind(this)}
                            addOrRemoveBloc={this.addOrRemoveBloc.bind(this)}
                        />
                    ),
                });
            });

        var signatureBlocType = this.props.blocTypes.find((bt) => bt.code === SIGNATURES_BLOC_TYPE_CODE);

        let expandedElement = null;

        if (!this.state.expanded) {
            expandedElement = (
                <IconButton
                    color="inherit"
                    // onClick={this.onBlocHeaderClick.bind(this)}
                    aria-label="Étendre"
                >
                    <ExpandMoreIcon />
                </IconButton>
            );
        } else {
            expandedElement = (
                <IconButton
                    color="inherit"
                    //onClick={this.onBlocHeaderClick.bind(this)}
                    aria-label="Réduire"
                >
                    <ExpandLessIcon />
                </IconButton>
            );
        }

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="container-with-footer col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <Accordion>
                        <AccordionSummary
                            className="without-side-padding ok-bloc"
                            onClick={this.onBlocHeaderClick.bind(this)}
                        >
                            <div className="row without-side-padding without-margin">
                                <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-2">
                                    {expandedElement}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding">
                                    <Typography>Infos générales</Typography>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className="intervention-panel-details">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
                                <DetailTab />
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <ReportTab
                        fieldValueChange={this.fieldValueChange.bind(this)}
                        addOrRemoveBloc={this.addOrRemoveBloc.bind(this)}
                    />
                    {categoryTabs.map((sc) => sc.content)}
                    <VariableTab
                        key={removableCategories.length}
                        category={signatureBlocType.category_id}
                        fieldValueChange={this.fieldValueChange.bind(this)}
                        addOrRemoveBloc={this.addOrRemoveBloc.bind(this)}
                        signature={true}
                    />
                </div>
                <FooterFixedOnScreen>
                    <div className="row">
                        <div className="col-lg-1 col-md-2 col-sm-4 col-6">
                            <Fab onClick={this.cancelSignature.bind(this)} color="primary" className="div-center">
                                <Icon>arrow_back</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Retour au contrôle</span>
                        </div>
                        <div className="offset-lg-10 col-lg-1 offset-md-8 col-md-2 offset-sm-4 col-sm-4 col-6">
                            <div className="center">
                                {this.props.intervention.state === "performed" ? (
                                    <div>
                                        <Fab
                                            onClick={this.confirmationPopup.bind(this)}
                                            className="green-button div-center"
                                        >
                                            <Icon>check</Icon>
                                        </Fab>
                                        <span className="floating-btn-text span-center">Valider</span>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </FooterFixedOnScreen>
                <ImputationRedirectionModal closeModal={this.closeImputationRedirectionModal.bind(this)} />
                <UpdatingBlocModal
                    updatingBloc={this.props.updatingBloc}
                    fieldValueChange={this.fieldValueChange.bind(this)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blocTypes: state.interventions.blocTypes,
        intervention: state.intervention.currentIntervention,
        blocs: state.intervention.blocs,
        updatingBloc: state.intervention.updatingBloc,
        activeUser: state.activeUser,
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
        sppFound: state.analyseRisques.sppFound,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fieldValueChange: (blocId, fieldId, value, blocs, userId, intervention) =>
            dispatch(fieldValueChange(blocId, fieldId, value, blocs, userId, intervention)),
        saveIntervention: (intervention, blocs) => submitInterventionInDb(intervention, blocs),
        cancelSignature: (history, imputationRedirection) => dispatch(cancelSignature(history, imputationRedirection)),
        loadCurrentTimeSlot: (blocs, blocTypes, user) => dispatch(loadCurrentTimeSlot(blocs, blocTypes, user)),
        setImputationRedirectionModalOpenned: (value) => dispatch(setImputationRedirectionModalOpenned(value)),
        interventionsIsLoading: (value) => dispatch(interventionsIsLoading(value)),
        validateSignature: (intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor) =>
            dispatch(validateSignature(intervention, timeSlot, blocs, user, blocTypes, history, stateAccessor)),
        throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
        throwInfo: (infoObject) => dispatch(throwInfo(infoObject)),
    };
};

export default compose(withRouter, withAuth, connect(mapStateToProps, mapDispatchToProps))(InterventionSignature);
